import { SetPageMusicLinkColorMode } from "@max/common/setpage";
import { getImageBrightness } from "Utils/getImageBrightness";

export const getColorMode = async (
  url: string,
): Promise<SetPageMusicLinkColorMode> => {
  const brightness = await getImageBrightness(url);
  return brightness > 255 / 2 ? "light" : "dark";
};
